import type { appShell as en } from "../en/app-shell";
import type { Messages } from "../types";

export const appShell: Messages<typeof en> = {
  groups: {
    engage: "التفاعل",
    content: "المحتوى",
    automate: "الأتمتة",
    insights: "الرؤى",
    collapse: "طيّ {{group}}",
    expand: "توسيع {{group}}",
  },
  nav: {
    label: "القائمة الرئيسية",
    home: "الرئيسية",
    inbox: "صندوق الوارد",
    approvals: "الموافقات",
    people: "الأشخاص",
    everyone: "الجميع",
    commenters: "المعلّقون",
    calendar: "التقويم",
    posts: "المنشورات",
    studio: "استوديو الذكاء",
    rules: "القواعد",
    agents: "الوكلاء الأذكياء",
    log: "سجل الأتمتة",
    dashboards: "لوحات المتابعة",
    analytics: "التحليلات",
    settings: "الإعدادات",
    admin: "إدارة المنصة",
    compose: "إنشاء منشور",
    jobs: "المهام",
    assistant: "المساعد",
    more: "المزيد",
  },
  org: {
    label: "المؤسسة",
    switch: "تبديل المؤسسة",
    yours: "مؤسساتك",
    create: "إنشاء مؤسسة",
    switched: "أنت الآن في {{name}}",
    current: "المؤسسة الحالية",
  },
  topbar: {
    searchOrAsk: "ابحث أو اسأل…",
    ask: "اسأل",
    askHint: "اسأل المساعد",
    reconnecting: "جارٍ إعادة الاتصال…",
    offline: "غير متصل",
    connection: "الاتصال",
    live: "مباشر",
    breadcrumb: "مسار التنقل",
  },
  avatar: {
    theme: "المظهر",
    help: "المساعدة والشروط",
    privacy: "سياسة الخصوصية",
    terms: "شروط الخدمة",
    dataDeletion: "حذف البيانات",
  },
  palette: {
    recent: "الأخيرة",
    organizations: "المؤسسات",
    settings: "الإعدادات",
    askQuery: "اسأل المساعد: «{{q}}»",
    newAgent: "إنشاء وكيل ذكي",
    newDashboard: "إنشاء لوحة متابعة",
    invite: "دعوة زميل",
    connect: "ربط إنستغرام",
    floatingOn: "إظهار زر «اسأل» العائم",
    floatingOff: "إخفاء زر «اسأل» العائم",
  },
  shortcuts: {
    goTo: "انتقال إلى",
    ask: "فتح المساعد",
    holdSpace: "اضغط مطولاً على المسافة",
    goPeople: "الانتقال إلى الأشخاص",
    goPosts: "الانتقال إلى المنشورات",
    goStudio: "الانتقال إلى استوديو الذكاء",
    goRules: "الانتقال إلى القواعد",
    goAgents: "الانتقال إلى الوكلاء الأذكياء",
    goLog: "الانتقال إلى سجل الأتمتة",
    goDashboards: "الانتقال إلى لوحات المتابعة",
    goSettings: "الانتقال إلى الإعدادات",
    goJobs: "الانتقال إلى المهام",
    goAssistant: "الانتقال إلى المساعد",
    aliases: "ما زال G U (القواعد) يعمل.",
  },
  floating: {
    title: "زر «اسأل» العائم",
    hint: "يضيف زر «اسأل» عائماً أسفل كل صفحة. زر «اسأل» في الشريط العلوي و{{key}} J يعملان دائماً.",
    label: "إظهار زر «اسأل» العائم",
  },
};
